import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../../core/services/user.service';
import { TokensDto, UserDto } from '../../core/models/api.models';
import { PlaylistsService } from '../../core/services/playlists.service';
import { addIcons } from 'ionicons';
import { sparklesOutline, shieldCheckmarkOutline, mailOutline } from 'ionicons/icons';

@Component({
  selector: 'app-home',
  templateUrl: './home.page.html',
  styleUrls: ['./home.page.scss']
})
export class HomePage implements OnInit {
  user?: UserDto | null;
  tokens?: TokensDto | null;

  constructor(public userService: UserService, public router: Router, private playlistsService: PlaylistsService) {
    addIcons({ sparklesOutline, shieldCheckmarkOutline, mailOutline });
  }

  ngOnInit(): void {
    this.userService.loadMe().subscribe(user => (this.user = user));
    this.loadTokens();
  }

  gotoConvert(): void {
    this.router.navigateByUrl('/app/convert');
  }

  gotoPlaylists(): void {
    this.router.navigateByUrl('/app/playlists');
  }

  private loadTokens(): void {
    this.playlistsService.getMyTokens().subscribe({
      next: res => (this.tokens = res),
      error: () => (this.tokens = null)
    });
  }
}
